import { __assign, __read, __rest } from "tslib";
import * as React from 'react';
import { useOnOutsideClick } from '@mercell/use-on-outside-click-react-hook';
import { useEffect, useRef, useState } from 'react';
import { usePopper } from 'react-popper';
import { twMerge } from 'tailwind-merge';
export var DropdownMenu = function (_a) {
    var id = _a.id, children = _a.children, className = _a.className, onClose = _a.onClose, anchorRef = _a.anchorRef, _b = _a.closeOnClick, closeOnClick = _b === void 0 ? false : _b, _c = _a.popperOptions, popperOptions = _c === void 0 ? {} : _c, _d = _a.ignoreOutsideClickClassName, ignoreOutsideClickClassName = _d === void 0 ? 'ignore-outside-click' : _d, _e = _a.isOutsideClickDisabled, isOutsideClickDisabled = _e === void 0 ? false : _e, rest = __rest(_a, ["id", "children", "className", "onClose", "anchorRef", "closeOnClick", "popperOptions", "ignoreOutsideClickClassName", "isOutsideClickDisabled"]);
    var placement = popperOptions.placement;
    var _f = __read(useState(anchorRef.current), 2), anchorEl = _f[0], setAnchorEl = _f[1];
    var _g = __read(useState(null), 2), popperElement = _g[0], setPopperElement = _g[1];
    var dropdownRef = useRef(popperElement);
    var _h = usePopper(anchorEl, popperElement, __assign(__assign({}, popperOptions), { placement: placement || 'bottom-start' })), styles = _h.styles, attributes = _h.attributes;
    useOnOutsideClick(dropdownRef, function (evt) {
        if ((anchorRef.current && anchorRef.current.contains(evt.target)) ||
            evt.target === anchorRef.current) {
            return;
        }
        onClose(evt);
    }, ignoreOutsideClickClassName, isOutsideClickDisabled);
    var handleClickInDropdown = function (event) {
        if (closeOnClick) {
            onClose(event);
        }
    };
    useEffect(function () { return setAnchorEl(anchorRef.current); }, [anchorRef]);
    useEffect(function () {
        if (dropdownRef.current !== popperElement) {
            dropdownRef.current = popperElement;
        }
    }, [popperElement]);
    if (!anchorRef.current) {
        return null;
    }
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("div", __assign({}, rest, attributes.popper, { ref: setPopperElement, onClick: handleClickInDropdown, style: styles.popper, tabIndex: -1, id: id, role: "menu", className: twMerge('w-[calc(100%-4px) ml-[2px] mt-1 z-[200] shadow-[0_1px_4px_0_#72727226] border border-alto rounded-default sm-dropdown:min-w-[160px] sm-dropdown:max-w-[250px] bg-white', className) }), children));
};
